import { connect } from "react-redux";

const AvatarPage = (props) => {
   const { page } = props;
   return (
      <span content={page.name} className="app-avatar app-avatar-circle app-avatar-image" style={{ width: 24, height: 24, lineHeight: '24px', background: 'rgb(34, 201, 147)' }}>
         <img src={page.page_avatar} />
      </span>
   )
}

const mapStateToProps = (state) => {
   const { page } = state;
   return {
      page
   };
};

export default connect(mapStateToProps, {})(AvatarPage)